import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Product } from '../types';

interface CartItem {
  product: Product;
  quantity: 1;
}

interface CartStore {
  items: CartItem[];
  isOpen: boolean;
  addItem: (product: Product) => void;
  removeItem: (productId: string) => void;
  clearCart: () => void;
  openCart: () => void;
  closeCart: () => void;
  total: () => number;
  itemCount: () => number;
  hasItem: (productId: string) => boolean;
}

export const useCartStore = create<CartStore>()(
  persist(
    (set, get) => ({
      items: [],
      isOpen: false,

      addItem: (product) => {
        const already = get().items.find(i => i.product.id === product.id);
        if (!already) {
          set(s => ({ items: [...s.items, { product, quantity: 1 }], isOpen: true }));
        } else {
          set({ isOpen: true });
        }
      },

      removeItem: (productId) =>
        set(s => ({ items: s.items.filter(i => i.product.id !== productId) })),

      clearCart: () => set({ items: [], isOpen: false }),

      openCart: () => set({ isOpen: true }),
      closeCart: () => set({ isOpen: false }),

      total: () =>
        get().items.reduce((sum, i) => sum + (i.product.is_free ? 0 : i.product.price), 0),

      itemCount: () => get().items.length,

      hasItem: (productId) => get().items.some(i => i.product.id === productId),
    }),
    { name: 'aiphra-cart', partialize: s => ({ items: s.items }) }
  )
);
